/**
 * Why a promo code could not be applied. Values are lower-case so the UI can map them straight to
 * translation keys (`promo_code_error_<reason>`).
 */
enum PromoCodeValidationReasonEnum {
    NOT_FOUND = "not_found",
    INACTIVE = "inactive",
    NOT_STARTED = "not_started",
    EXPIRED = "expired",
    MIN_SUBTOTAL_NOT_MET = "min_subtotal_not_met",
    MAX_USES_REACHED = "max_uses_reached",
    ALREADY_USED_BY_CUSTOMER = "already_used_by_customer",
}

export default PromoCodeValidationReasonEnum;
